module.exports = __webpack_public_path__ + "static/media/wind-speed.f505e40c.svg";